export const subjectWiseChartColorMap: any = {
  HINDI: {
    other: '#E890B3',
    baseline: '#FFE1ED',
    endline: '#FFC3DB',
    diffrence: '#D16C94',
  },
  MATHS: {
    other: '#CFED79',
    baseline: '#ECF8C9',
    endline: '#D9F194',
    diffrence: '#AEC962',
  },
  MATHEMATICS: {
    other: '#CFED79',
    baseline: '#ECF8C9',
    endline: '#D9F194',
    diffrence: '#AEC962',
  },
  ENGLISH: {
    other: '#328DF6',
    baseline: '#C1DDFC',
    endline: '#84BBFA',
    diffrence: '#2871C5',
  },
  EVS: {
    other: '#FFC391',
    baseline: '#FFE7D3',
    endline: '#FFCFA7',
    diffrence: '#E1A574',
  },
  OTHER: {
    other: '#21A2BF',
    baseline: '#BCE3EC',
    endline: '#7AC7D9',
    diffrence: '#1A8299',
  },
};

export const schollWiseChartColorMap = {
  controllCountColor: '#90c4e5',
  treatmentCountColor: '#a5bd60',
};
export const contol_treatment_colorMap: any = {
  control: {
    other: '#328DF6',
    baseline: '#C1DDFC',
    endline: '#84BBFA',
    diffrence: '#2871C5',
  },
  treatment: {
    other: '#CFED79',
    baseline: '#ECF8C9',
    endline: '#D9F194',
    diffrence: '#AEC962',
  },
};
export const logoImagesMap: any = {
  PragatiApp: '/images/Pragati Logo 120X60 px.PNG',
  PragatiAPP: '/images/Pragati Logo 120X60 px.PNG',
  IprogressAPP: '/images/iProgressV2Logo.PNG',
  IvsiApp: '/images/iversusi Logo 120X60 px.PNG',
};
